<template>
  <div class="composer" v-if="account == null">
    <div class="editor">
      <div class="flexeditor">
        <div class="flexeditorarea-dummy" aria-hidden="true">コメントするためにはログインしてください</div>
      </div>
    </div>
  </div>
  <div class="composer" v-else>
    <div class="user">
      <c-account-image v-if="account != null" :has-img = "account.has_img" :account-id = "account.id" :account-name = "account.name" />
    </div>
    <div class="editor">
      <div class="flexeditor" :style="styles">
        <mentionable
          :keys="data.keys"
          :items="data.items"
          :limit="data.mentionLimit"
          insert-space
          @open="onOpen">
          <textarea 
            class="flexcommenteditor" placeholder="コメントを書く" 
            v-model="data.text" 
            ref="area" :style="styles"></textarea>
          <template #no-result>
            <div class="dim">
              No result
            </div>
          </template>
          <template #item-@="{ item }">
            <div class="destination" v-if="!item.groupFlg">
              {{ item.lastName + item.firstName }}
              <span class="dim">
                {{ item.nickname }}
              </span>
            </div>
            <div class="group" v-else>
              {{ item.name }}
              <span class="dim">
                ({{ item.count }}名)
              </span>
            </div>
          </template>
        </mentionable>
      </div>
    </div>
    <font-awesome-icon :icon="['far', 'grin-alt']" size="lg" :style="{ color:'#9197A3', marginLeft:'10px', marginTop:'20px', cursor: 'pointer'}" @click="()=>{data.emojiDialog =! data.emojiDialog}" />
    <!-- <button @click="comment">click</button> -->
    <c-emoji-dialog v-show="data.emojiDialog" @add-emoji="(val) => { addEmoji(val) }" />
    <button @click="comment">コメントする</button>
  </div>
</template>
<script setup>
import axios from 'axios'
import Global from '@/js/constant.js'
import mention from '@/js/components/mention.js'
import mentionUtils from '@/js/mention-utils.js'
import _ from 'lodash'

import { useStore } from 'vuex'
import { useToast } from 'vue-toast-notification'
import { computed, defineProps, nextTick, onMounted, reactive, useTemplateRef, watch } from 'vue'

const $store = useStore()
const $toast = useToast()
const $refArea = useTemplateRef('area')

// props : {
const props = defineProps({
  entry: {
    type: Object,
    required: true
  },    
  defaultAccounts : {
    type: Array,
    required: false
  },
  refreshFlg : {
    type: Boolean,
    required: true
  }
})
// data
const {mentionStates, getDestinations} = mention()

const data = reactive({
  text: null,
  destinationIds: null,
  hashtagIds: null,
  destinationGroupIds: null,
  items: [],
  keys: ['@'],
  mentionLimit: Global.vue_mention_limit,
  emojiDialog: false,
  height:'70px'
})
const styles = computed(() => {
  return {
    "height": data.height,
  }
})

// mapstate
const account = computed(() => $store.state.core.account)
const circleMode = computed(() => $store.state.circle.circleMode)
const loginFlg = computed(() => $store.state.core.loginFlg)

// mapmutations
const setCommentReloadEntryId = (val) => $store.commit('setCommentReloadEntryId', val)
const setClientErrors = (val) => $store.commit('setClientErrors', val)

// watch
watch(() => data.items, () => {
  if (data.items.length < 100 && data.items.length > Global.vue_mention_limit) {
    data.mentionLimit = data.items.length
  }
})
watch(account, () => {
  getDestinations(props.entry.entry_division_id, props.entry.circle_id)
})
watch(() => props.refreshFlg, (val) => {
  if (val) {
    data.text= null
    setMentionsText()
  }
})
watch(() => props.defaultAccounts, () => {
  setMentionsText()
})
watch(() => data.text, () => {
  resize()
})

onMounted(async () => {
  _.forEach(document.getElementsByClassName("mentionable"), (row)=>{row.removeAttribute('style')})
  setMentionsText()

  await getDestinations(props.entry.entry_division_id, props.entry.circle_id)
})

// methods
// const getDestinations = () => {
//   let url = mentionUtils.getDestinationsUrl(this.entry.entry_division_id)
//   let params = mentionUtils.getDestinationParameters(this.entry.entry_division_id, this.entry.circle_iis.acco.valueunis.acco.valueunt.id)
//   this.axios.post(url, params).then(res => {
//     if (res.data.status === Global.api_status.success) {
//    is.acco.valueunts = mentionUtils.getApiResponse(res)
//       this.items = _.mis.acco.valueunts, (row) => {
//         return mentionUtils.getMentionStates(row)
//       })
//       return
//     }
//   })
//   .catch(error=>{
//     console.log(error)
//     $toast.error('client error')
//     setClientErrors({func:"common/entry/comment.vue::getDestinations", params: params, errorMessage:error})
//   })
//   .finally(()=>{
//     if (this.entry.circle_id != null) {
//       // TODO
//       this.getGroup()
//     }
//   })
// }
// const getGroup = () => {
//   let circle = _.keyBy(this.circles, 'id')[this.entry.circle_id];
//   this.groups = circle.groups
//   this.items = this.items.concat(_.map(this.groups, (row) => {
//     return mentionUtils.getMentionGroupsStates(row)
//   }))
//   this.groupToAccounts = mentionUtils.createGroupMentionToMembersMentionConverter(this.groups)
//   if (this.items.length > 0) {
//     this.items = this.items.concat(mentionUtils.getHereState())
//   }
// }
const comment = () => {
  if (isMentionOpen())  return
  if (!loginFlg.value) {
    $toast.error("please login!")
    return
  }
  if (mentionUtils.isEpty(data.text, mentionStates.accounts, mentionStates.groups, mentionStates.hashtags)) {
    $toast.error("no comment")
    return
  }
  data.destinationGroupIds = mentionUtils.getGroupIdsFromText(data.text, mentionStates.groups)
  data.text = mentionUtils.changeGroupToMembers(data.text, mentionStates.groupToAccounts)
  data.destinationIds = mentionUtils.getDestinationIdsFromText(data.text, mentionStates.accounts, mentionStates.groups)
  data.text = mentionUtils.deleteAccountIdFromText(data.text, mentionStates.accounts, mentionStates.groups)
  // alert(data.text)
  // return
  var formData = new FormData()
  formData.append("insert_flg", Global.ON)
  formData.append("entry_division_id", props.entry.entry_division_id)
  formData.append("text", data.text)
  formData.append("account_id", account.value.id)
  formData.append("reply_id", props.entry.id)
  formData.append("all_dest_flg", mentionUtils.getAllDestFlg(data.text))
  if (data.hashtagIds)     formData.append("hashtag_ids", data.hashtagIds)
  if (data.destinationIds) formData.append("destination_ids", data.destinationIds)
  if (data.destinationGroupIds) formData.append("destination_group_ids", data.destinationGroupIds)
  if (props.entry.circle_id) formData.append("circle_id", props.entry.circle_id)
  if (props.entry.circle_id) formData.append("official_circle", getOffcialCircle())
  if (props.entry.circle_id) formData.append("official_range",  0)
  axios.post(Global.url.api_entries_tweet, formData)
  .then(res => {
    if (res.data.status == Global.api_status.success) {
      data.text = ''
      mail(res.data.entry.id)
      $toast.success("success")
      setMentionsText()
      setCommentReloadEntryId(props.entry.id)
      return
    }
    $toast.error("failed")
  })
  .catch(error=>{
    console.dir(error)
    $toast.error('client error')
    setClientErrors({func:"components/entry/comment.vue::comment", params: formData, errorMessage:error})
  })
}
const getOffcialCircle  = () => {
  if (circleMode.value == Global.circle_mode.public) return true
  if (circleMode.value == Global.circle_mode.private) return false
}
const mail = (entryId) => {
  let params = { entry_id: entryId }
  axios.post(Global.url.api_entries_reply_email, params)
  .then(res => {
    if (res.data.status === Global.api_status.success) {
      return
    }
    setClientErrors({func:"components/entry/comment.vue::mail", params: params, errorMessage:JSON.stringify(res.data)})
  })
  .catch(error=>{
    console.dir(error)
    $toast.error('client error')
    setClientErrors({func:"components/entry/comment.vue::mail", params: params, errorMessage:error})
  })
}
const setMentionsText = () => {
  if (props.entry.entry_as_circle) return
  let _mentionsText = ''
  _.forEach(props.defaultAccounts, (row)=>{
    if (_mentionsText.indexOf(mentionUtils.getMentionStates(row).value) != -1) return
    if (!row.id) return
    _mentionsText += (_mentionsText && ' ') + '@'+mentionUtils.getMentionStates(row).value
  })
  if (_mentionsText != '') data.text = _mentionsText + '\n'
}
const isMentionOpen = () => {
  return document.querySelectorAll('.v-popover.popper.open').length > 0
}
const addEmoji = (val) => {
  if (val) {
    data.text = data.text + val
  }
  data.emojiDialog = false
}
const resize = () => {
  data.height =  `${$refArea.value.scrollHeight}px`
  data.height = "auto"
  nextTick(() => {
    data.height = `${$refArea.value.scrollHeight}px`
  })
}
const onOpen = () => {
  data.items = mentionStates.mentionDestinations
}
</script>